module.exports = __webpack_public_path__ + "img/2-5.9a709e7f.svg";